<button popovertarget="mapkey-popover" class="clear" (keydown.escape)="remove.emit()" role="button" aria-haspopup="true"
        aria-expanded="false">
    <cll-input-chip appearance="outlined" colour="secondary"
                    [style.anchor-name]="'--mapKeyAnchor'">
        Map key
    </cll-input-chip>
</button>
<div [style.position-anchor]="'--mapKeyAnchor'"
     class="map-key-popover"
     id="mapkey-popover"
     popover>

    <cll-card appearance="elevated">
        <div class="map-key">
            @for (icon of icons; track icon.key) {
                <div class="map-key-item">
                    <span class="map-icon"><img src="data:image/svg+xml;base64,{{ icon.svg }}"
                                                alt="icon for {{ icon.text }}" /></span>
                    <span class="map-label">{{ icon.text }}</span>
                </div>
            }
        </div>

    </cll-card>
</div>
